import { SVG_PROP_TYPE } from '@eventbrite/legacy-eds.vector-image';

// PropTypes
export const ILLUSTRATION_TYPE_PROP_TYPE = SVG_PROP_TYPE;
